export const DATA_FIRESTORE_V01_EVENT_POLICIES = {
  NAME: 'v01_event_policies',
}
